import type { EstimateLevel } from '../../types';
import { getEstimateLevelLabel } from '../../utils/pricing';

interface EstimateLevelSelectorProps {
  value: EstimateLevel;
  onChange: (level: EstimateLevel) => void;
}

const levels: EstimateLevel[] = ['min', 'med', 'max'];

export function EstimateLevelSelector({
  value,
  onChange,
}: EstimateLevelSelectorProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-600 mr-2">Stima:</span>
      <div className="inline-flex rounded-lg bg-gray-100 p-1">
        {levels.map((level) => (
          <button
            key={level}
            onClick={() => onChange(level)}
            className={`
              px-4 py-1.5 text-sm font-medium rounded-md transition-all
              ${
                value === level
                  ? 'bg-white text-primary-700 shadow-sm'
                  : 'text-gray-600 hover:text-gray-900'
              }
            `}
          >
            {getEstimateLevelLabel(level)}
          </button>
        ))}
      </div>
    </div>
  );
}
